<template>
  <!-- Keep this field empty: it catches bots that fill every form field. -->
  <div class="form-honeypot" aria-hidden="true">
    <label>
      Website
      <input
        :value="value"
        @input="$emit('input', $event.target.value)"
        type="text"
        name="website"
        tabindex="-1"
        autocomplete="off"
      />
    </label>
  </div>
</template>

<script>
export default {
  name: "FormHoneypot",
  props: {
    value: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.form-honeypot {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  clip-path: inset(50%);
  white-space: nowrap;
  pointer-events: none;
}
</style>
